export const phoneTypes = ['Business', 'Home', 'Mobile', 'Other'];

export interface Phone {
  type: string;
  number: string;
}
